import { supabase } from '@/integrations/supabase/client';
import type { QueryClient } from '@tanstack/react-query';

/**
 * Performs a clean logout that prevents cross-session data leaks.
 * Clears React Query cache, storage, and does a full page reload.
 */
export async function cleanLogout(queryClient: QueryClient) {
  try {
    // 1. Clear React Query cache BEFORE signOut
    queryClient.clear();

    // 2. Clear storage
    localStorage.clear();
    sessionStorage.clear();

    // 3. Supabase signOut
    await supabase.auth.signOut();
  } catch (err) {
    console.error('[cleanLogout] Error during logout:', err);
  } finally {
    // 4. Full page reload — forces total JS memory reset
    window.location.href = '/login';
  }
}
